module.exports = __webpack_public_path__ + "img/bottom.fa10b21d.png";